export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  useAppInsights: false,
  appInsightsInstrumentationKey: 'e6f30bb6-a160-4d69-a8d2-8642430020c1',
  useTimeout: false,
  idleInterval: 1800,
  build: 'Test',
  version: '2.0.10',
  displaySidebar: true,
  theme: 'light',
  publicApi: 'https://test-wems.oha.oregon.gov/api/public/',
  privateApi: 'https://test-wems-admin.oha.oregon.gov/api/private/',
  canManageB2CUsers: true,
  auth: {
    defaultAuth: "B2C", //options: AAD or B2C
    useAdIdentity: false,
    b2c: {
      clientId: '3b8da10a-3aaf-4023-ada7-f9a03c3e379b',
      authority: 'https://wemsdevb2c.b2clogin.com/',
      authorityDomain:'wemsdevb2c.b2clogin.com/',
      domain: 'wemsdevb2c.onmicrosoft.com/',
      signUpSignInPolicy: 'B2C_1_WEMS_DEV_SUSI',
      scopes: ['openid','https://wemsdevb2c.onmicrosoft.com/3b8da10a-3aaf-4023-ada7-f9a03c3e379b/User.Access'],
      redirectUri: 'https://test-wems-admin.oha.oregon.gov',
      postLogoutRedirectUri: 'https://test-wems-admin.oha.oregon.gov'
    },
    aad: {
      clientId: '817cff66-e6a4-44a7-a218-37e196c91493',
      scopes: ['api://817cff66-e6a4-44a7-a218-37e196c91493/user.access'],
      groups: ['8474cfc8-154b-4507-b834-3eb85a9bd5d0'],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/',
      redirectUri: 'https://test-wems-admin.oha.oregon.gov',
    }
  },
  enableHttpsRedirect: false,
  staffInbox: "chae.shin@odhsoha.oregon.gov",
  wemsHelpLink: "https://www.oregon.gov/oha/PH/DISEASESCONDITIONS/CHRONICDISEASE/HPCDPCONNECTION/TOBACCO/Documents/WEMSCountyUserManualRevisedDecember2024.pdf"
};
